import PropTypes from 'prop-types';

import { Card, HelpIcon, IconButton, LoaderSkeleton } from '@utilities';

import styles from './_index.module.scss';

const MetricCard = ({ isLoading, label, value }) => (
  <Card className={styles['metric-card']} padding="medium">
    <p className={styles['metric-label']}>{label}</p>
    {isLoading ? (
      <LoaderSkeleton height={20} width={80}>
        <rect height="20" rx="2" ry="2" width="80" x="0" y="0" />
      </LoaderSkeleton>
    ) : (
      <p className={styles['metric-value']}>{value ?? '—'}</p>
    )}
  </Card>
);

MetricCard.propTypes = {
  isLoading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
};

const OverviewMetrics = ({ excludedCount, includedCount, isLoading }) => (
  <section className={styles['overview-metrics']}>
    <div className={styles['overview-header-row']}>
      <h3 className={styles['overview-header']}>Overview</h3>
      {/* Help link placeholder goes to HC homepage for now until article is written. */}
      <IconButton
        aria-label="Response Quality Help"
        as="a"
        className={styles['help-link']}
        href="https://help.numerator.com/en/"
        target="_blank"
        tooltip="Response Quality Help"
      >
        <HelpIcon />
      </IconButton>
    </div>
    <div className={styles['metric-cards']}>
      <MetricCard isLoading={isLoading} label="Included in Results" value={includedCount} />
      <MetricCard isLoading={isLoading} label="Excluded from Results" value={excludedCount} />
    </div>
  </section>
);

OverviewMetrics.propTypes = {
  excludedCount: PropTypes.number,
  includedCount: PropTypes.number,
  isLoading: PropTypes.bool,
};

export default OverviewMetrics;
